export default "__VITE_ASSET__DDpQ38qC__"